import tw from 'tailwind-styled-components';
import styled from 'styled-components';
import { Title } from '../Typography';

export const UpperRightCornerAsset = styled.div`
  position: absolute;
  right: 0%;
  top: -5%;
  z-index: 1;

  @media screen and (max-width: 768px) {
    right: -7%;
    top: 7%;
    width: 45%;
  }
`;
UpperRightCornerAsset.displayName = 'UpperRightCornerAsset';

export const UpperLeftCornerAsset = styled.div`
  position: absolute;
  left: 0;
  top: -3%;
  z-index: 2;
  width: 27.08%;
  max-width: 390px;
  height: auto;
  max-height: 390px;

  @media screen and (max-width: 767px) {
    top: 20px;

    width: 70%;
    max-width: 224px;
    max-height: 224px;
  }
`;
UpperLeftCornerAsset.displayName = 'UpperLeftCornerAsset';

export const LowerLeftCornerAsset = styled.div`
  position: absolute;
  left: 0%;
  bottom: 150px;
  z-index: 1;

  @media screen and (max-width: 768px) {
    left: -19%;
    bottom: 4%;
    width: 55%;
  }
`;
LowerLeftCornerAsset.displayName = 'LowerLeftCornerAsset';

export const LowerRightCornerAsset = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 12;
  width: 27.77%;
  max-width: 400px;
  height: auto;
  max-height: 400px;
  @media screen and (max-width: 767px) {
    z-index: 2;
    width: 59.37%;
    max-width: 190px;
    max-height: 190px;
  }
`;
LowerRightCornerAsset.displayName = 'LowerRightCornerAsset';

export const CopyContainer = styled.div`
  background: #e8ebe8;
  position: relative;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 767px) {
    padding: 0px 22px 0px 22px;
    min-height: 1025px;
  }
  @media screen and (min-width: 768px) {
    padding: 0px;
    min-height: 1158px;
  }
`;

CopyContainer.displayName = 'CopyContainer';

export const MainContent = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  z-index: 3;
  position: relative;
  @media screen and (min-width: 768px) {
    width: 66.27%;
    margin: auto;
  }
`;
MainContent.displayName = 'MainContent';

export const Object1 = styled.div`
  position: absolute;
  left: 25%;
  top: 14%;
  z-index: 2;

  @media screen and (max-width: 767px) {
    left: 50%;
    top: 72px;
  }
`;
Object1.displayName = 'Object1';

export const Object2 = styled.div`
  position: absolute;
  left: 10%;
  top: 35%;
  z-index: 2;
  transform: rotate(122deg);

  @media screen and (max-width: 767px) {
    left: 54%;
    top: 158px;
    z-index: 2;
    transform: rotate(276deg);
  }
`;
Object2.displayName = 'Object2';

export const Object3 = styled.div`
  position: absolute;
  left: -47px;
  top: 50%;
  z-index: 2;
  transform: rotate(181deg);

  @media screen and (max-width: 767px) {
    left: -26px;
  }
`;
Object3.displayName = 'Object3';

export const Object4 = styled.div`
  position: absolute;
  left: 30%;
  bottom: 25%;
  z-index: 2;

  @media screen and (max-width: 767px) {
    transform: rotate(260deg);
    left: 68%;
    bottom: 200px;
  }
`;
Object4.displayName = 'Object4';

export const Object5 = styled.div`
  position: absolute;
  right: 21%;
  bottom: 14%;
  z-index: 2;
  transform: rotate(19deg);

  @media screen and (max-width: 767px) {
    right: 36%;
    bottom: 58px;
  }
`;
Object5.displayName = 'Object5';

export const SuperText = tw.p`
  text-center
  mb-2
  text-darkgray
  opacity-70
  pt-0.5
  font-neutral
  text-xs
  leading-4
  uppercase
  tracking-xl
  lg:text-sm
  md:leading-4.5
`;
SuperText.displayName = 'SuperText';

export const DescriptionText = tw.p`
  text-center
  text-sm
  lg:text-base
`;
DescriptionText.displayName = 'DescriptionText';

export const ProductTitle = tw(Title)`
  text-center
  mb-2.5
  text-4xl
  lg:text-6xl
  xl:text-7xl
`;
ProductTitle.displayName = 'ProductTitle';

export const LinkContainer = tw.div`
absolute
  text-center
`;

export const StyledLinkComponent = styled(LinkContainer as any)`
  top: 100%;
  left: 50%;
  transform: translate(-150px, -75px);
  @media (min-width: 768px) {
    top: 100%;
    transform: translate(-175px, -100px);
  }
  @media (width: 320px) {
    transform: translate(-108px, -75px);
  }
`;
StyledLinkComponent.displayName = 'StyledLinkComponent';

export const ButtonStyled = styled.div`
  display: block;
  @media (max-width: 768px) {
    display: none;
  }
`;
ButtonStyled.displayName = 'ButtonStyled';

export const ButtonMobileStyled = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;
ButtonMobileStyled.displayName = 'ButtonMobileStyled';

export const MobileLeaf = tw.div`
block
md:hidden
`;
MobileLeaf.displayName = 'MobileLeaf';

export const DesktopLeaf = tw.div`
hidden
md:block
`;
DesktopLeaf.displayName = 'DesktopLeaf';

export const ParentContainer = tw.div`relative
overflow-hidden
pt-0
md:pt-9`;
ParentContainer.displayName = 'ParentContainer';

export const CtaButton = styled.div`
  margin: auto;
  margin-top: 20px;
  width: 200px;
  height: 50px;
  position: relative;
  @media (min-width: 768px) {
    margin-top: 30px;
    width: 250px;
  }
`;
